import { useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import AddCircleIcon from '../../../../../assets/icons/add-circle-stroke-rounded'
import AddNetworkModal from '../../../../../components/AddNetworkModal'
import InfoBox from '../../../../../components/InfoBox'
import PageWrapper from '../../../../../components/Pagewrapper'
import Table from '../../../../../components/Table/Table'
import { useGetNetworksQuery } from '../../../../../redux/services/coreApi'
import { setNetworksTableState } from '../../../../../redux/slices/tableFiltersSlice'
import { RootState } from '../../../../../redux/store'
import { CurrencyDto, NetworkDto } from '../../../../../types/coreApi-types'
import ImageAndValue from '../SystemWallets/components/ImageAndValue'
import EditNetworkModal from './components/EditNetworkModal'

type NetworksScreenProps = {}

const NetworksScreen: React.FC<NetworksScreenProps> = () => {
  const { data: networks, isLoading } = useGetNetworksQuery()
  const [selectedNetwork, setSelectedNetwork] = useState<NetworkDto | null>(
    null
  )
  const { isOpen, onOpen, onClose } = useDisclosure()
  const addNetworkModal = useDisclosure()

  const networksTableState = useSelector(
    (state: RootState) => state.networksTable
  )

  const handleEditNetwork = (network: NetworkDto) => {
    setSelectedNetwork(network)
    onOpen()
  }

  const handleCloseEditModal = () => {
    onClose()
    setSelectedNetwork(null)
  }

  return (
    <PageWrapper title="Networks Overview">
      <Table
        tableState={networksTableState}
        setTableState={setNetworksTableState}
        navigate={() => null}
        isLoading={isLoading}
        onClickRow={(network: NetworkDto) => handleEditNetwork(network)}
        emptyDataRender={<div className="text-xl mb-3">No networks found</div>}
        // @ts-expect-error
        defaultData={
          networks?.map(item => ({
            ...item,
            active: item.active ? 'Active' : 'Inactive',
          })) ?? []
        }
        schema={[
          {
            header: 'Name',
            accessorKey: 'name',
            type: 'string',
            priority: 1,
            cellValueWrapper: (value, originalValue, { original }) => (
              <div className="w-min">
                <ImageAndValue
                  value={value || 'Unknown'}
                  iconUrl={original?.iconUrl}
                />
              </div>
            ),
          },
          {
            header: 'ISO Code',
            accessorKey: 'isoCode',
            type: 'string',
            priority: 2,
            cellValueWrapper: value => (
              <div className="w-min">
                {value ? value : <span className="text-gray-400">-</span>}
              </div>
            ),
          },
          {
            header: 'Native Currency',
            accessorKey: 'nativeCurrency',
            type: 'string',
            priority: 3,
            cellValueWrapper: (value, originalValue, { original }) => (
              <div className="w-min">
                {value ? (
                  <ImageAndValue
                    value={(value as unknown as CurrencyDto).name}
                    iconUrl={(value as unknown as CurrencyDto).iconUrl}
                    tooltip
                  />
                ) : (
                  <span className="text-gray-400">-</span>
                )}
              </div>
            ),
          },
          {
            header: 'Status',
            accessorKey: 'active',
            type: 'status',
            priority: 4,
            cellValueWrapper: (value, originalValue, row) => (
              <div className="w-min flex flex-col">
                <InfoBox colorScheme={value === 'Active' ? 'green' : 'red'}>
                  {value === 'Active' ? 'Active' : 'Inactive'}
                </InfoBox>
              </div>
            ),
          },
          {
            header: 'Updated At',
            accessorKey: 'updatedAt',
            type: 'string',
            priority: 5,
            cellValueWrapper: value => (
              <div>
                {value ? (
                  moment.utc(value).local().format('MMM D, YYYY HH:mm')
                ) : (
                  <span className="text-gray-400">-</span>
                )}
              </div>
            ),
          },
        ]}
      />

      <div className="flex justify-end mt-6">
        <button
          className="button flex items-center gap-2 bg-primary text-white hover:bg-primary-dark transition-colors"
          onClick={addNetworkModal.onOpen}
        >
          <AddCircleIcon width={20} height={20} color="white" />
          <span>Add Network</span>
        </button>
      </div>

      <EditNetworkModal
        isOpen={isOpen}
        onClose={handleCloseEditModal}
        network={selectedNetwork}
      />
      <AddNetworkModal
        isOpen={addNetworkModal.isOpen}
        onClose={addNetworkModal.onClose}
      />
    </PageWrapper>
  )
}

export default NetworksScreen
